angular.module('unica_wiki.wiki_controllers')

.controller('WikiCreateController', function(
	$rootScope, $scope, $state,
	WikiCreateService
) {

	$scope.pageTitle = 'Aggiungi Dato';

	$scope.saveWiki = function() {
		$scope.showLoader();

		var wikiData = angular.copy($rootScope.wikiData);

		if ( typeof wikiData.image !== "undefined" ) {
			wikiData.image = wikiData.image.dataURL;
		} else {
			wikiData.image = '';
		}

		if ( wikiData.introduction_date ) {
			var introductionDate = moment(wikiData.introduction_date);
			wikiData.introduction_date = introductionDate.format('YYYY-MM-DD');
		}


		WikiCreateService
			.create(wikiData)
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.showSuccessMsg('Dato aggiunto con successo!', '');
					$rootScope.wikiData = {};
					$state.go('app.wiki.list');
				} else {
					$rootScope.manageError(data);
				}
			});

	};

	$scope.removeImage = function() {
		$rootScope.wikiData.image = '';
	};

})

;
